<template>
    <!-- 国内机票查看订单 -->
    <div>
        <div class="Details_data">
            <h4>订单信息</h4>
            <div class="Details_text">
                <span>订单号：{{detailData.orderNo||defaultText}}</span>
                <span>订单状态: {{detailData.orderStatusText||defaultText}}</span>
                <span>航程类型：{{detailData.flightTypeText||defaultText}}</span>
                <span>下单人：{{detailData.placeOrderPsg||defaultText}}</span>
                <span>预定时间：{{detailData.orderTime||defaultText}}</span>
                <span>订单总价：￥{{detailData.totalPrice.totalPay||defaultText}}</span>
                <span>支付方式：{{detailData.payTypeText||defaultText}}</span>
                <span>交易时间：{{detailData.payTime||defaultText}}</span>
                <span>出票时间：{{detailData.ticketTime||defaultText}}</span>
                <span
                    v-if="detailData.fullReductionAmount"
                >实际支付金额：￥{{detailData.payAmount||defaultText}}</span>
                <span class="price" v-if="detailData.fullReductionAmount">
                    优惠金额：￥{{detailData.fullReductionAmount||defaultText}}
                    <el-popover placement="bottom" width="500" trigger="hover">
                        <div
                            class="activity_text"
                            v-for="(item,index) in detailData.fullReductionSnapshot"
                            :key="index"
                        >
                            <p>
                                <b>{{index}}</b>
                                {{item}}
                            </p>
                        </div>
                        <b slot="reference">优惠说明</b>
                    </el-popover>
                </span>
            </div>
        </div>
        <div class="content-list">
            <h2>航班信息</h2>
            <div class="content_table">
                <table width="99%">
                    <tr>
                        <th>航程类型</th>
                        <th>航班号</th>
                        <th>出发城市</th>
                        <th>到达城市</th>
                        <th>起飞时间</th>
                        <th>到达时间</th>
                        <th>舱位</th>
                        <th>飞行时长</th>
                        <th>产品类型</th>
                        <th>退改规则</th>
                        <th>政策描述</th>
                    </tr>
                    <tr v-for="(flight,index) in detailData.segmentList" :key="index">
                        <td>{{flight.segmentTypeText}}</td>
                        <td>
                            <p>
                                {{flight.flightNo}}
                                {{flight.airlineName}}
                            </p>
                        </td>
                        <td>
                            <p>
                                {{flight.sCityName}}
                                {{flight.sTerminal}}
                                {{flight.sAirportCode}}
                            </p>
                        </td>
                        <td>
                            <p>
                                {{flight.eCityName}}
                                {{flight.eTerminal}}
                                {{flight.eAirportCode}}
                            </p>
                        </td>
                        <td>
                            {{flight.beginDate}}
                            {{flight.beginTime}}
                        </td>
                        <td>
                            {{flight.arriveDate}}
                            {{flight.arriveTime}}
                        </td>
                        <td>
                            {{flight.cabinCode}}
                            {{flight.cabinName}}
                        </td>
                        <td>
                            {{flight.duration}}
                            <span>停飞{{flight.stopNum}}次</span>
                        </td>
                        <td>{{flight.productTypeText}}</td>
                        <td>
                            <el-popover placement="bottom" title="" width="500" trigger="hover">
                                <chang-clause
                                    :ruleText="ruleText"
                                    :luggage="luggage"
                                    style="font-size:13px;"
                                ></chang-clause>
                                <span
                                    slot="reference"
                                    @mouseenter="backRule(flight)"
                                    style="color:#409EFF"
                                >退改规则</span>
                            </el-popover>
                        </td>
                        <td>
                            <el-popover placement="bottom" title="" width="400" trigger="hover">
                                <div class="policy_text">
                                    <p>温馨提示：{{flight.domPolicy.content}}</p>
                                    <p>
                                        <span>工作时间:{{flight.domPolicy.providerWorkTime}}</span>
                                        <br>
                                        <span>废票时间:{{flight.domPolicy.refundTime}}</span>
                                    </p>
                                </div>
                                <span slot="reference" style="color:#409EFF">政策描述</span>
                            </el-popover>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="content-list">
            <h2>乘客信息</h2>
            <div class="content_table">
                <table width="99%">
                    <tr>
                        <th>乘客姓名</th>
                        <th>乘客类型</th>
                        <th>证件类型</th>
                        <th>证件号码</th>
                        <th>出生日期</th>
                        <th>手机号码</th>
                        <th>票号</th>
                        <th>新票号</th>
                        <th v-if="$route.query.psgType!=1">成人PNR</th>
                        <th v-if="$route.query.psgType!=1">成人舱位</th>
                        <th v-if="$route.query.psgType!=1">成人票号</th>
                        <th>操作</th>
                    </tr>
                    <tr v-for="(item,index) in detailData.passengerList" :key="index">
                        <td>{{item.psgName}}</td>
                        <td>{{item.psgTypeText}}</td>
                        <td>{{item.cardTypeText}}</td>
                        <td>{{item.cardNo}}</td>
                        <td>{{item.birthday}}</td>
                        <td>{{item.mobile}}</td>
                        <td>
                            <!-- <div v-if="item.initTicketNumber">
                                <p v-for="(initTicketNumber,index) in item.initTicketNumber.split(',')" :key="index"
                                v-if="item.initTicketNumber.indexOf(',')!=-1">{{initTicketNumber}}</p>
                                <span v-else>{{item.initTicketNumber}}</span>
                            </div>-->

                            <div v-if="item.ticketNumberList.length>0">
                                <template v-if="item.ticketNumberList[0].initTicketNumber">
                                    <p
                                        v-for="(s,index) in item.ticketNumberList[0].initTicketNumber.split(',')"
                                        :key="index"
                                    >{{s}}</p>
                                </template>
                                <!-- <template v-else>
                                    <p
                                        v-for="(s,index) in item.ticketNumberList[0].newTicketNumber.split(',')"
                                        :key="index"
                                    >{{s}}</p>
                                </template>-->
                            </div>
                        </td>
                        <td>
                            <!-- <div v-if="item.newTicketNumber">
                                <p v-for="(newTicketNumber,index) in item.newTicketNumber.split(',')" :key="index"
                                v-if="item.newTicketNumber.indexOf(',')!=-1">{{newTicketNumber}}</p>
                                <span v-else>{{item.newTicketNumber}}</span>
                            </div>-->

                            <div v-if="item.ticketNumberList.length>0">
                                <!-- <template v-if="item.ticketNumberList[0].initTicketNumber">
                                    <p
                                        v-for="(s,index) in item.ticketNumberList[0].initTicketNumber.split(',')"
                                        :key="index"
                                    >{{s}}</p>
                                </template>-->

                                <template v-if="item.ticketNumberList[0].newTicketNumber">
                                    <p
                                        v-for="(s,index) in item.ticketNumberList[0].newTicketNumber.split(',')"
                                        :key="index"
                                    >{{s}}</p>
                                </template>
                                <p v-else>----</p>
                            </div>
                        </td>
                        <td
                            v-if="$route.query.psgType!=1"
                        >{{item.ticketNumberList[0].adultPnr || '----'}}</td>
                        <td
                            v-if="$route.query.psgType!=1"
                        >{{item.ticketNumberList[0].adultCabin|| '----'}}</td>
                        <td
                            v-if="$route.query.psgType!=1"
                            @click="goPage(item.ticketNumberList[0].adultOrderNo,item.psgType)"
                            style="color:#237dc8;cursor:pointer"
                        >
                            <!-- <span
                                style="color:#237dc8;cursor:pointer"
                            >{{item.ticketNumberList[0].adultTicketNumber|| '----'}}</span>-->
                            <p
                                v-for="(s,index) in item.ticketNumberList[0].adultTicketNumber.split(',')"
                                :key="index"
                                v-if="item.ticketNumberList[0].adultTicketNumber.indexOf(',')!=-1"
                            >{{s}}</p>
                            <p v-else>{{item.ticketNumberList[0].adultTicketNumber}}</p>
                        </td>
                        <td>
                            <el-button
                                type="text"
                                size="mini"
                                @click="$router.push({name:'air-ticket-admin-ItineraryNotice',query:{ticketNumber:item.ticketNumberList[0].newTicketNumber
                                ||item.ticketNumberList[0].initTicketNumber}})"
                            >打印通知单</el-button>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="content-list">
            <h2>联系信息</h2>
            <div class="content_table">
                <table width="99%">
                    <tr>
                        <th>联系人</th>
                        <th>联系电话</th>
                        <th>邮箱</th>
                        <th>备注</th>
                    </tr>
                    <tr>
                        <td>{{detailData.contactName}}</td>
                        <td>{{detailData.contactTel}}</td>
                        <td>{{detailData.contactEmail}}</td>
                        <td>{{detailData.remark}}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="content-list">
            <h2>票价信息</h2>
            <div class="content_table-color">
                <table width="99%">
                    <tr>
                        <td>订单总价:</td>
                        <td>¥{{detailData.totalPrice.totalPay}}</td>
                        <td>订单结算总价:</td>
                        <td>¥{{detailData.totalPrice.supTotalPay}}</td>
                        <td>订单票面总价:</td>
                        <td>¥{{detailData.totalPrice.totalPrice}}</td>
                    </tr>
                    <tr>
                        <td>返佣总金额:</td>
                        <td>¥{{detailData.totalPrice.totalRebatePrice}}</td>
                        <td>成人税金:</td>
                        <td>¥{{detailData.totalPrice.taxes||0}}</td>
                        <template v-if="Number(detailData.totalPrice.billingFee)>0">
                            <td>支付手续费：</td>
                            <td>
                                <i>￥</i>
                                {{detailData.totalPrice.billingFee}}
                            </td>
                        </template>
                        <template v-else>
                            <td></td>
                            <td></td>
                        </template>
                    </tr>
                </table>
            </div>
        </div>
        <div class="content-list" v-if="detailData.individualPrice.length">
            <h2>单人票价信息</h2>
            <div
                class="content_table-color"
                v-for="(price,priceIndex) in detailData.individualPrice"
                :key="priceIndex"
            >
                <table width="99%">
                    <tr v-if="price.aduPrice">
                        <td
                            v-if="detailData.individualPrice.length>1"
                        >{{price.segmentType==1?'去程':'回程'}}</td>
                        <td>成人单人总结算价:</td>
                        <td>¥ {{price.aduSettlementPrice}}</td>
                        <td>成人单人票面价:</td>
                        <td>¥ {{price.aduPrice}}</td>
                        <td>成人单人返佣:</td>
                        <td>
                            ¥ {{
                            countAduPrice(price)
                            }}
                        </td>
                    </tr>
                    <tr v-if="price.chiSettlementPrice">
                        <td
                            v-if="detailData.individualPrice.length>1"
                        >{{price.segmentType==1?'去程':'回程'}}</td>
                        <td>儿童单人结算价:</td>
                        <td>¥ {{price.chiRebate}}</td>
                        <td>儿童单人票面价:</td>
                        <td>¥ {{price.chiSettlementPrice}}</td>
                        <td>儿童单人返佣:</td>
                        <td>{{price.chiRebate}}%</td>
                    </tr>
                </table>
            </div>
        </div>
        <!-- <div class="content-list">
            <h2>行李信息</h2>
            <div class="luggage-info fs13">
                <p>免费托运：20KG,每人1件,单件体积不超过40×60×100CM。</p>
                <p>免费手提行李额：10KG,每人1件,单件体积不超过20×40×55CM。</p>
                <p>具体费用按航空公司官网规定收取。</p>
            </div>
        </div>-->
    </div>
</template>
<script>
import ChangClause from "./changClause";

export default {
  name: "InlandOrderInfo",
  data() {
    return {
      ruleText: "",
      luggage: "",
      defaultText: "------"
    };
  },
  components: { ChangClause },
  methods: {
    countAduPrice(detailPrice) {
      let price =
        parseInt(detailPrice.aduPrice) -
        parseInt(detailPrice.aduSettlementPrice);
      if (price <= 0) {
        return 0;
      } else {
        return price;
      }
    },
    goPage(val, psgType) {
      if (!val) return;
      this.$router.push({
        name: "air-ticket-admin-airDetails",
        query: { ordersNo: val, psgType: 1 }
      });
      setTimeout(() => {
        this.$router.go(0);
      }, 300);
    },
    //退改规则
    backRule(val) {
      let refRule = val.rule.refRule;
      let chaRule = val.rule.chaRule;
      this.luggage = val.luggage;
      if (refRule && chaRule) {
        refRule = val.rule.refRule.rules;
        chaRule = val.rule.chaRule.rules;
        refRule.map(item => (item.type = "refRule"));
        chaRule.map(item => (item.type = "chaRule"));
        this.ruleText = [refRule, chaRule];
      }
    }
  },
  created() {},
  props: ["detailData"]
};
</script>
<style lang="less" scoped>
@import "~@/lib/deprecated/styles/common.less";
.content-list {
  @contentBox();
}
.content_table {
  @contentTable();
}
.content_table-color {
  @contentTableColor();
}
.luggage-info {
  padding: 10px 25px;
  p {
    padding: 5px 0;
  }
}

.Details_data {
  background: #fffcfa;
  border: solid 1px #ffb27f;
  h4 {
    padding-left: 30px;
    color: #666666;
    font-size: 16px;
    font-weight: 400;
    padding: 8px 30px;
    background: #fff5ef;
  }
  .Details_text {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 20px 30px;
    span {
      display: inline-block;
      width: 33%;
      font-size: 13px;
      color: #666;
      line-height: 25px;
      height: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .price {
      overflow: initial;
      display: flex;
      align-items: center;
      b {
        cursor: pointer;
        color: #237dd2;
        margin-left: 10px;
      }
    }
  }
}
.policy_text {
  font-size: 13px;
  color: #666;
  p:first-child {
    line-height: 25px;
    color: red;
    span {
      line-height: 25px;
    }
  }
}
.activity_text {
  font-size: 13px;
  color: #666;
  text-align: justify;
  p {
    line-height: 25px;
  }
}
</style>
